import React from 'react';
import { LeavingGuard } from '@components/utils/LeavingGuard';
import { Button, Fieldset, HeadContent, Loading, Select, Subsection, Table, } from '@fourthwall/components';
import { ConfirmBar } from '@modules/Dashboard/modules/ConfirmBar';
import { routing } from '@utils/routing';
import { BadgesSkeleton } from './BadgesSkeleton';
import { useBadgesContext } from './hooks/useBadgesContext';
import { BadgesProvider } from './providers/BadgesProvider';
import { FormFields } from './providers/BadgesProvider/types';
const BadgesContent = () => {
    const badges = useBadgesContext();
    if (badges.isFetching)
        return React.createElement(BadgesSkeleton, null);
    return (React.createElement(React.Fragment, null,
        React.createElement(HeadContent, { title: "Badges" }),
        React.createElement(Subsection, { title: "Badges", rightContent: React.createElement(Button, { label: "Create a new badge", appearance: "primary", size: "small", to: routing.memberships.settings.badges.create }) },
            React.createElement(Table, { ...badges.table, isLoading: badges.isLoading })),
        React.createElement(Subsection, { title: "Number of badges to show in comments" },
            React.createElement(Fieldset, null,
                React.createElement(Fieldset.Row, null, "Control the maximum number of badges that show up next to a member\u2019s name in the comments."),
                React.createElement(Fieldset.Row, null,
                    React.createElement(Loading, { isLoading: badges.isLoading },
                        React.createElement("div", { style: { width: '100%' } },
                            React.createElement(Select, { label: "Number of badges", ...badges.form.getFieldProps(FormFields.uncollapsedBadgesCount), value: badges.form.values[FormFields.uncollapsedBadgesCount], options: [
                                    {
                                        label: '1 (recommended for label badges)',
                                        value: '1',
                                        key: '1',
                                    },
                                    {
                                        label: '2',
                                        value: '2',
                                        key: '2',
                                    },
                                    {
                                        label: '3 (recommended for minimal badges)',
                                        value: '3',
                                        key: '3',
                                    },
                                    {
                                        label: '4',
                                        value: '4',
                                        key: '4',
                                    },
                                    {
                                        label: '5',
                                        value: '5',
                                        key: '5',
                                    },
                                ] })))))),
        React.createElement(ConfirmBar, { isOpen: badges.form.dirty, isLoading: badges.isLoading, onConfirm: badges.form.submitForm, onCancel: badges.form.resetForm }),
        React.createElement(LeavingGuard, { when: badges.form.dirty, isValid: badges.form.isValid, onSave: badges.form.submitForm })));
};
export const Badges = () => (React.createElement(BadgesProvider, null,
    React.createElement(BadgesContent, null)));
